<template>
    <div class="container mb-5 bg-light py-3" style="margin-top: 145px; border-radius: 16px;">
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <h1 class="displayMain">Asesoría</h1>
                <p class="displayText mt-5">Manda tus datos y nosotros nos comunicamos contigo</p>
                <p class="displayText mt-2 text-danger">
                    NOTA: La asesoría tiene un costo de <b>$350.00 MXN</b>
                </p>

                <!-- Bolitas de progreso -->
                <div class="row col-12 justify-content-center mb-3">
                    <div class="col-6">
                        <div class="align-center">
                            <div :class="['circle text-light', paso === 1 ? 'bg-primary' : 'bg-secondary']">
                                <b>1</b>
                            </div>
                            <p class="text-dark pt-2" style="font-size: 14px"><b>Datos personales</b></p>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="align-center">
                            <div :class="['circle text-light', paso === 2 ? 'bg-primary' : 'bg-secondary']">
                                <b>2</b>
                            </div>
                            <p class="text-dark pt-2" style="font-size: 14px"><b>Fecha y hora</b></p>
                        </div>
                    </div>
                </div>

                <!-- Paso 1: formulario -->
                <form v-if="paso === 1" class="row" @submit.prevent="evaluarInputs">
                    <div class="mb-3 col-12 col-md-6">
                        <label class="form-label">Nombre</label>
                        <input v-model="form.nombre" type="text" class="form-control" placeholder="Nombre" />
                    </div>
                    <div class="mb-3 col-12 col-md-6">
                        <label class="form-label">Apellido</label>
                        <input v-model="form.apellido" type="text" class="form-control" placeholder="Apellido" />
                    </div>
                    <div class="mb-3 col-12">
                        <label class="form-label">¿Cuéntanos a dónde quieres viajar y cuáles son tus
                            expectativas?</label>
                        <textarea v-model="form.expectativas" class="form-control" rows="3"></textarea>
                    </div>

                    <button type="submit" class="btn btn-dark text-light" style="font-size: 16px">
                        <b>Siguiente</b>
                    </button>
                </form>

                <!-- Paso 2: calendario -->
                <div v-if="paso === 2" class="col-12" style="padding: 28px;">
                    <FullCalendar :options="calendarOptions" />
                </div>
            </div>

            <!-- Imagen -->
            <div class="col-12 col-md-6 row justify-content-end">
                <div class="col-12 col-md-10">
                    <img src="0ceba48e1e4bdb5910091e1c1c0377e1.png" class="img-fluid rounded" alt="imagen" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";


import Swal from "sweetalert2";
import axios from "axios";

export default {
    name: "AsesoriasWeb",
    components: { FullCalendar },
    data() {
        return {
            paso: 1,
            form: { nombre: "", apellido: "", expectativas: "" },
            events: [],
            calendarOptions: {
                initialView: "dayGridMonth",
                plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                events: [],
                eventClick: null,
                locale: "es",
                dateClick: null,
                dayCellDidMount: null,
                buttonText: {
                today: "Día Actual", // Cambia "Hoy" a "Día Actual"
                month: "Mes", // Cambia "Month" a "Mes"
                week: "Semana", // Cambia "Week" a "Semana"
                day: "Día", // Cambia "Day" a "Día"
                list: "Agenda", // Cambia "List" a "Agenda"
            },
            },
        };
    },
    mounted() {
        // Asignar eventos y callbacks después de montar
        this.calendarOptions.events = this.events;
        this.calendarOptions.eventClick = this.showevent;
        this.calendarOptions.dateClick = this.handleDateClick;
        this.calendarOptions.dayCellDidMount = this.highlightSundays;
        this.fetchEvents();
    },
    methods: {
        async fetchEvents() {
            try {
                const { data } = await axios.get("https://beauvoyage.net/api/showR");

                // Mapear eventos
                const mappedEvents = data.map((item) => ({
                    id: item.id,
                    title: item.title,
                    start: item.date,
                    extendedProps: {
                        nameUser: item.nameUser,
                        apellidoUser: item.apellidoUser,
                        experiencia: item.experiencia,
                        horario: item.horario,
                    },
                }));

                // Asignar a la propiedad reactiva de FullCalendar
                this.calendarOptions.events = mappedEvents;

                // Opcional: si usas 'events' separado
                this.events = mappedEvents;
            } catch (error) {
                console.error("Error cargando eventos:", error);
            }
        },

        evaluarInputs() {
            const { nombre, apellido, expectativas } = this.form;
            if (!nombre || !apellido || !expectativas) {
                Swal.fire("Error", "Complete todos los campos para continuar", "error");
                return;
            }
            this.paso = 2; // pasa al calendario
        },

        async handleDateClick(info) {
            // Ignorar domingos
            if (info.date.getDay() === 0) return;

            const selectedDate = info.dateStr;
            const today = new Date();
            today.setHours(0, 0, 0, 0); // ignorar hora
            const inputDate = new Date(selectedDate);
            inputDate.setHours(0, 0, 0, 0);

            // Validación de fecha
            if (inputDate < today) {
                Swal.fire({
                    text: "Fecha inválida",
                    icon: "error",
                });
                return; // salir si la fecha es pasada
            }

            // Si es hoy o futura, continuar
            // Eventos ocupados de ese día
            const response = await axios.get("https://beauvoyage.net/api/showR");
            const eventos = response.data.filter((e) => e.date === selectedDate);

            const horariosBase =
                info.date.getDay() === 6
                    ? [
                        "9:00 am - 10:00 am",
                        "10:00 am - 11:00 am",
                        "11:00 am - 12:00 am",
                        "12:00 am - 1:00 pm",
                        "1:00 pm - 2:00 pm",
                        "2:00 pm - 3:00 pm",
                        "3:00 pm - 4:00 pm",
                        "4:00 pm - 5:00 pm",
                        "5:00 pm - 6:00 pm",
                        "6:00 pm - 7:00 pm",
                        "7:00 pm - 8:00 pm",
                        "8:00 pm - 9:00 pm",
                        "9:00 pm - 10:00 pm",
                        "10:00 pm - 11:00 pm",
                        "11:00 pm - 12:00 pm",
                    ]
                    : [
                        "4:00 pm - 5:00 pm",
                        "5:00 pm - 6:00 pm",
                        "6:00 pm - 7:00 pm",
                        "7:00 pm - 8:00 pm",
                        "8:00 pm - 9:00 pm",
                    ];

            const horariosOcupados = eventos.map((e) => e.horario);
            const horariosDisponibles = horariosBase.filter(
                (h) => !horariosOcupados.includes(h)
            );

            if (horariosDisponibles.length === 0) {
                Swal.fire("Sin disponibilidad", "Ese día ya está lleno", "info");
                return;
            }

            let optionsHtml = `<option value="" disabled selected>Elige una opción</option>`;
            horariosDisponibles.forEach(
                (h) => (optionsHtml += `<option value="${h}">${h}</option>`)
            );

            Swal.fire({
                title: "Selecciona un horario",
                html: `<select id="miSelect" class="swal2-input">${optionsHtml}</select>`,
                confirmButtonText: "Aceptar",
                preConfirm: () => {
                    const selectedValue = document.getElementById("miSelect").value;
                    if (!selectedValue) {
                        Swal.showValidationMessage("Debes seleccionar una opción");
                        return false;
                    }
                    return selectedValue;
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const formData = {
                        title: "Reservación",
                        date: selectedDate,
                        nameUser: this.form.nombre,
                        apellidoUser: this.form.apellido,
                        experiencia: this.form.expectativas,
                        horario: result.value,
                    };

                    try {
                        await axios.post("https://beauvoyage.net/api/reservations", formData);
                        Swal.fire("¡Excelente!", "Reservación añadida con éxito", "success");
                        this.fetchEvents(); // recargar eventos
                    } catch (error) {
                        Swal.fire("Error", "No se pudo guardar la reservación", "error");
                    }
                }
            });
        },


        highlightSundays(info) {
            if (info.date.getDay() === 0) {
                info.el.style.backgroundColor = "#f4f4f4";
                const link = info.el.querySelector("a");
                if (link) link.style.pointerEvents = "none";
            }
        },
    },
};
</script>

<style scoped>
.circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
